var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("grid-table", {
    staticClass: "flex grow",
    attrs: { "data-qa": `group-table:${_vm.tableTitle}` },
    scopedSlots: _vm._u([
      {
        key: "head",
        fn: function () {
          return [
            _c(
              "grid-table-row",
              [
                _c(
                  "grid-table-cell",
                  { attrs: { width: _vm.prefixColumnWidth } },
                  [_vm._v("\n                #\n            ")]
                ),
                _vm._v(" "),
                _c(
                  "grid-table-cell",
                  { attrs: { width: _vm.prefixColumnWidth } },
                  [
                    _c("base-icon", {
                      attrs: { name: _vm.groupCollapsedComputedIconName },
                      on: { click: _vm.toggleAllRows },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._l(_vm.headers, function (header, index) {
                  return _c(
                    "grid-table-cell",
                    {
                      key: header,
                      attrs: {
                        "text-align": _vm.textAlignments[index],
                        width: _vm.widths[index],
                      },
                    },
                    [_vm._v(_vm._s(header))]
                  )
                }),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.hasGroups
              ? _vm._l(_vm.groups, function (group, groupIndex) {
                  return _c(
                    "div",
                    { key: group.groupName },
                    [
                      _c(
                        "grid-table-row",
                        {
                          attrs: { "is-clickable": true },
                          on: {
                            click: function ($event) {
                              return _vm.toggleRow(group.groupName)
                            },
                          },
                        },
                        [
                          _c(
                            "grid-table-cell",
                            {
                              attrs: {
                                "table-cell": "",
                                width: _vm.prefixColumnWidth,
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(groupIndex + 1) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "grid-table-cell",
                            { attrs: { width: _vm.prefixColumnWidth } },
                            [
                              _c("base-icon", {
                                attrs: {
                                  name: _vm.computedIconName(group.groupName),
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(group.groupData, function (cell, index) {
                            return _c(
                              "grid-table-cell",
                              {
                                key: `group-header-content-cell:${index}`,
                                attrs: {
                                  "text-align": _vm.textAlignments[index],
                                  width: _vm.widths[index],
                                },
                              },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(cell.title) +
                                    "\n                            "
                                ),
                                cell.tooltip
                                  ? _c(
                                      "tooltip",
                                      { attrs: { text: cell.tooltip } },
                                      [
                                        _c("base-icon", {
                                          attrs: { name: "circle-info" },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _vm.isRowExpanded(group.groupName)
                        ? _vm._l(
                            group.groupEntries,
                            function (source, groupIndex) {
                              return _c(
                                "grid-table-row",
                                { key: groupIndex, staticClass: "_pb-0 _ba-0" },
                                [
                                  _c(
                                    "grid-table-cell",
                                    {
                                      attrs: {
                                        width: 2 * _vm.prefixColumnWidth,
                                      },
                                    },
                                    [_c("span")]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(source, function (cell, index) {
                                    return [
                                      index === _vm.leafIndex
                                        ? _c(
                                            "grid-table-leaf",
                                            {
                                              key: `table-content-leaf:${index}`,
                                              attrs: {
                                                "is-last-leaf":
                                                  groupIndex ===
                                                  group.groupEntries.length - 1,
                                                "text-align":
                                                  _vm.textAlignments[index],
                                                width: _vm.widths[index],
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(cell) +
                                                  "\n                            "
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "grid-table-cell",
                                            {
                                              key: `table-content-cell:${index}`,
                                              attrs: {
                                                "text-align":
                                                  _vm.textAlignments[index],
                                                width: _vm.widths[index],
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                " +
                                                  _vm._s(cell) +
                                                  "\n                            "
                                              ),
                                            ]
                                          ),
                                    ]
                                  }),
                                ],
                                2
                              )
                            }
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                })
              : [
                  _c(
                    "grid-table-row",
                    { attrs: { "is-filled": true } },
                    [
                      _c("grid-table-cell", { attrs: { "is-empty": true } }, [
                        _vm._v("There is no data to show"),
                      ]),
                    ],
                    1
                  ),
                ],
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }